import "@material/react-linear-progress/dist/linear-progress.css";
import LinearProgress from "@material/react-linear-progress";
import React from "react";

export const LoadingBar: React.FC<{ loading: boolean }> = ({ loading }) => {
  if (!loading) return null;
  return <LinearProgress indeterminate />;
};
